import { DotsThree, Info, PencilSimple, Trash } from "@phosphor-icons/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface ResellerRowActionsProps {
	onDetails: () => void;
	onEdit: () => void;
	onDelete: () => void;
	isDeleting: boolean;
}

export function ResellerRowActions({
	onDetails,
	onEdit,
	onDelete,
	isDeleting,
}: ResellerRowActionsProps) {
	const { t } = useTranslation();
	const [showDeleteDialog, setShowDeleteDialog] = useState(false);

	return (
		<>
			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<Button variant="ghost" size="icon" aria-label={t("common.actions")}>
						<DotsThree className="size-4" weight="bold" />
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent align="end">
					<DropdownMenuItem onClick={onDetails}>
						<Info className="size-4" />
						{t("resellers.details")}
					</DropdownMenuItem>
					<DropdownMenuItem onClick={onEdit}>
						<PencilSimple className="size-4" />
						{t("resellers.edit")}
					</DropdownMenuItem>
					<DropdownMenuSeparator />
					<DropdownMenuItem
						variant="destructive"
						disabled={isDeleting}
						onClick={() => setShowDeleteDialog(true)}
					>
						<Trash className="size-4" />
						{t("resellers.delete")}
					</DropdownMenuItem>
				</DropdownMenuContent>
			</DropdownMenu>
			<AlertDialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogTitle>{t("resellers.deleteTitle")}</AlertDialogTitle>
						<AlertDialogDescription>
							{t("resellers.deleteDescription")}
						</AlertDialogDescription>
					</AlertDialogHeader>
					<AlertDialogFooter>
						<AlertDialogCancel>{t("resellers.cancel")}</AlertDialogCancel>
						<AlertDialogAction onClick={onDelete}>
							{t("resellers.delete")}
						</AlertDialogAction>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>
		</>
	);
}
